<template>
  <div>
    <div>
      <v-breadcrumbs
        class="px-0"
        :items="!isEdit
          ? [
              { title: 'Staff', href: '/setting/staff', color: 'primary', disabled: false },
              { title: 'Staff Account Settings', disabled: true },
            ]
          : [
              { title: 'Staff', href: '/setting/staff', color: 'primary', disabled: false },
              { title: `${lastName} ${firstName}`, href: `/setting/staff/${$route.params.id}`, color: 'primary', disabled: false },
              { title: 'Staff Account Settings', disabled: true },
            ]"
      ></v-breadcrumbs>
    </div>
    <page-title :value="$t('setting.staffAccountSettings')"></page-title>

    <v-form v-model="valid" ref="form">
      <v-container class="pt-12">
        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.category') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-select
              v-model="category"
              :items="categorySelectValues"
              item-title="text"
              item-value="value"
              variant="outlined"
              density="compact"
              hide-details
              :rules="[required]"
              color="primary"
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.lastName') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="lastName"
              :rules="[required]"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.firstName') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="firstName"
              :rules="[required]"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>


        <v-row align="center">
          <v-col cols="6" align-self="center">
            <div class="d-flex align-center">
              {{ $t('setting.staffForm.staffId') }}
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ props }">
                  <v-icon small v-bind="props"
                    >mdi-information-outline
                  </v-icon>
                </template>
                <span>{{ $t('setting.staffForm.staffIdTooltip') }}</span><br />
                <span>{{ $t('setting.staffForm.staffIdExample') }}</span><br />
                <span>{{ $t('setting.staffForm.staffIdExampleValue') }}</span><br />
                <span>{{ $t('setting.staffForm.staffIdWarning1') }}</span><br />
                <span>{{ $t('setting.staffForm.staffIdWarning2') }}</span>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="email"
              :rules="[required, isEmail]"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.dateOfBirth') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <date-picker v-model="birth"></date-picker>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.gender') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-select
              :items="genderSelectValues"
              v-model="gender"
              :rules="[required]"
              item-title="text"
              item-value="value"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.address') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="address"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.phoneNumber1') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="phoneNumber1"
              :rules="[isTel]"
              :placeholder="$t('setting.staffForm.phoneNumberPlaceholder')"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.phoneNumber2') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="phoneNumber2"
              :rules="[isTel]"
              :placeholder="$t('setting.staffForm.phoneNumberPlaceholder')"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="py-3">
          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.isDirector') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-checkbox v-model="isDirector" color="primary"></v-checkbox>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.isChief') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-checkbox v-model="isChief" color="primary"></v-checkbox>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6" align-self="center">
            <div>
              {{ $t('setting.staffForm.isAdmin') }}
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ props }">
                  <v-icon small v-bind="props"
                    >mdi-information-outline
                  </v-icon>
                </template>
                <span>{{ $t('setting.staffForm.adminTooltip') }}</span>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-checkbox v-model="isAdmin" color="primary"></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.staffCode1') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="staffCode1"
              variant="outlined"
              density="compact"
              hide-details
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.staffCode2') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field
              v-model="staffCode2"
              variant="outlined"
              density="compact"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.joinDate') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <date-picker v-model="joinDate"></date-picker>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.assignDate') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <date-picker v-model="assignDate"></date-picker>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.retireDate') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <date-picker v-model="retireDate" clearable></date-picker>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.retireReason') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-select
              :items="retireSelectValues"
              v-model="retireReason"
              item-title="text"
              item-value="value"
              density="compact"
              variant="outlined"
              hide-details
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center"> </v-col>
          <v-col cols="6" align-self="center">
            <v-textarea
              v-model="retireReasonComment"
              variant="outlined"
              density="compact"
              hide-details
              :label="$t('setting.staffForm.retireReasonDetail')"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.classInCharge') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-select
              :items="classes"
              v-model="classesInCharge"
              item-title="className"
              item-value="classId"
              variant="outlined"
              density="compact"
              hide-details
              multiple
              chips
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <div>{{ $t('setting.staffForm.remarks') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-textarea v-model="comment" variant="outlined" :label="$t('setting.staffForm.remarks')"> </v-textarea>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6" align-self="center">
            <div>{{ $t('setting.staffForm.isHidden') }}</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-checkbox v-model="isHidden"></v-checkbox>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="3">
            <v-btn
              v-if="isEdit"
              @click="updateStaff"
              :loading="loading"
              color="primary"
              variant="flat"
              block
            >
              {{ $t('common.save') }}
            </v-btn>

            <v-btn
              v-else
              @click="createStaff"
              :loading="loading"
              :disabled="!valid"
              color="primary"
              variant="flat"
              block
            >
              {{ $t('common.create') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script lang="ts">
import { staffModule } from "@/store/dataModules/staffModule";
import { defineComponent } from "vue";
import DatePicker from "@/components/atoms/DatePicker.vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import { classModule } from "@/store/dataModules/classModule";
import { staffEditModule } from "@/store/dataModules/staffEditModule";
import LocalDataService from "@/service/LocalDataService";
import Swal from "sweetalert2";
import ValidationMixin from "@/mixins/ValidationMixin";

export default defineComponent({
  name: "StaffEdit",

  mixins: [ValidationMixin],

  components: {
    DatePicker,
    PageTitle,
  },

  mounted() {
    this.getStaff();
    this.listClass();

    if (this.$route.params.id == "new") {
      staffEditModule.clearValues();

      // reset validation
      (this.$refs.form as any).resetValidation();
    }
  },

  data() {
    return {
      valid: false,
      loading: false,
      retireSelectValues: [
        { text: "", value: "" },
        { text: this.$t('setting.staffForm.retireTransfer'), value: "transfer" },
        { text: this.$t('setting.staffForm.retireRetire'), value: "retire" },
        { text: this.$t('setting.staffForm.retireDie'), value: "die" },
      ],
      categorySelectValues: [
        { text: this.$t('setting.staffForm.categoryGeneral'), value: "general" },
        { text: this.$t('setting.staffForm.categoryHelper'), value: "help" },
      ],
      genderSelectValues: [
        { text: "", value: "" },
        { text: this.$t('common.male'), value: "male" },
        { text: this.$t('common.female'), value: "female" },
      ],
    };
  },

  computed: {
    classes: function (): any[] {
      return classModule.classes.map((c) => {
        return {
          className: `${c.year}年度 ${c.className}`,
          classId: c.classId,
        };
      });
    },
    userNurseryId: function () {
      staffEditModule.setUserId(this.$route.params.id as string);
      return this.$route.params.id;
    },
    isEdit: function (): boolean {
      return this.$route.params.id == "new" ? false : true;
    },
    category: {
      get() {
        return staffEditModule.category;
      },
      set(value: "general" | "help") {
        staffEditModule.setCategory(value);
      },
    },
    firstName: {
      get() {
        return staffEditModule.firstName;
      },
      set(value: string) {
        staffEditModule.setFirstName(value);
      },
    },
    lastName: {
      get() {
        return staffEditModule.lastName;
      },
      set(value: string) {
        staffEditModule.setLastName(value);
      },
    },
    firstNameKana: {
      get() {
        return staffEditModule.firstNameKana;
      },
      set(value: string) {
        staffEditModule.setFirstNameKana(value);
      },
    },
    lastNameKana: {
      get() {
        return staffEditModule.lastNameKana;
      },
      set(value: string) {
        staffEditModule.setLastNameKana(value);
      },
    },
    staffCode1: {
      get() {
        return staffEditModule.staffCode1;
      },
      set(value: string) {
        staffEditModule.setStaffCode1(value);
      },
    },
    staffCode2: {
      get() {
        return staffEditModule.staffCode2;
      },
      set(value: string) {
        staffEditModule.setStaffCode2(value);
      },
    },
    email: {
      get() {
        return staffEditModule.email;
      },
      set(value: string) {
        staffEditModule.setEmail(value);
      },
    },
    isDirector: {
      get() {
        return staffEditModule.isDirector;
      },
      set(value: boolean) {
        staffEditModule.setIsDirector(value);
      },
    },
    isChief: {
      get() {
        return staffEditModule.isChief;
      },
      set(value: boolean) {
        staffEditModule.setIsChief(value);
      },
    },
    isAdmin: {
      get() {
        return staffEditModule.isAdmin;
      },
      set(value: boolean) {
        staffEditModule.setIsAdmin(value);
      },
    },
    birth: {
      get() {
        return staffEditModule.birth;
      },
      set(value: string) {
        staffEditModule.setBirth(value);
      },
    },
    gender: {
      get() {
        return staffEditModule.gender;
      },
      set(value: string) {
        staffEditModule.setGender(value);
      },
    },
    address: {
      get() {
        return staffEditModule.address;
      },
      set(value: string) {
        staffEditModule.setAddress(value);
      },
    },
    phoneNumber1: {
      get() {
        return staffEditModule.phoneNumber1;
      },
      set(value: string) {
        staffEditModule.setPhoneNumber1(value);
      },
    },
    phoneNumber2: {
      get() {
        return staffEditModule.phoneNumber2;
      },
      set(value: string) {
        staffEditModule.setPhoneNumber2(value);
      },
    },
    joinDate: {
      get() {
        return staffEditModule.joinDate;
      },
      set(value: string) {
        staffEditModule.setJoinDate(value);
      },
    },
    assignDate: {
      get() {
        return staffEditModule.assignDate;
      },
      set(value: string) {
        staffEditModule.setAssignDate(value);
      },
    },
    retireDate: {
      get() {
        return staffEditModule.retireDate;
      },
      set(value: string) {
        staffEditModule.setRetireDate(value);
      },
    },
    retireReason: {
      get() {
        return staffEditModule.retireReason;
      },
      set(value: "transfer" | "retire" | "die") {
        staffEditModule.setRetireReason(value);
      },
    },
    retireReasonComment: {
      get() {
        return staffEditModule.retireReasonComment;
      },
      set(value: string) {
        staffEditModule.setRetireReasonComment(value);
      },
    },
    classesInCharge: {
      get() {
        return staffEditModule.classesInCharge;
      },
      set(value: number[]) {
        staffEditModule.setclassesInCharge(value);
      },
    },
    comment: {
      get() {
        return staffEditModule.comment;
      },
      set(value: string) {
        staffEditModule.setComment(value);
      },
    },
    isHidden: {
      get() {
        return staffEditModule.isHidden;
      },
      set(value: boolean) {
        staffEditModule.setIsHidden(value);
      },
    },
  },

  methods: {
    async getStaff() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && this.isEdit) {
        await staffModule.getStaff({
          nurseryId: String(nurseryId),
          userNurseryId: this.userNurseryId as string,
        });
        this.setValues();
      }
    },
    async createStaff() {
      this.loading = true;
      if (this.checkValidation()) {
        const nurseryId = LocalDataService.getNurseryId();
        if (nurseryId) {
          const response = await staffEditModule.createStaff({
            nurseryId: String(nurseryId),
          });
          if (response) {
            Swal.fire({ title: this.$t('setting.staffForm.createSuccess'), icon: "success" });
            this.$router.push({ path: "/setting/staff" });
          } else {
            Swal.fire({ title: this.$t('setting.staffForm.createFailed'), icon: "error" });
          }
        }
      }
      this.loading = false;
    },
    async updateStaff() {
      this.loading = true;
      if (this.checkValidation()) {
        const nurseryId = LocalDataService.getNurseryId();
        if (nurseryId) {
          const response = await staffEditModule
            .updateStaff({
              nurseryId: String(nurseryId),
            })
            .catch((e) => {
              return;
            });
          if (response) {
            Swal.fire({ title: this.$t('setting.staffForm.saveSuccess'), icon: "success" });
            this.$router.push({ path: "/setting/staff" });
          } else {
            Swal.fire({
              title: this.$t('setting.staffForm.saveFailed'),
              icon: "error",
              html: `・${this.$t('setting.staffForm.saveFailedEmail')}<br>・${this.$t('setting.staffForm.saveFailedInvalid')}<br>・${this.$t('setting.staffForm.saveFailedOther')}`,
            });
          }
        }
      }
      this.loading = false;
    },
    async listClass() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule.listClass({
          nurseryId: nurseryId,
        });
      }
    },
    checkValidation(): boolean {
      if (this.birth && this.joinDate && this.assignDate && this.category) {
        return true;
      } else {
        Swal.fire({
          title: this.$t('setting.staffForm.errorTitle'),
          text: this.$t('setting.staffForm.errorRequiredFields'),
          icon: "warning",
        });
        return false;
      }
    },
    setValues() {
      if (staffModule.staffDetail) {
        staffEditModule.setCategory(staffModule.staffDetail.category);
        staffEditModule.setFirstName(staffModule.staffDetail.firstName);
        staffEditModule.setLastName(staffModule.staffDetail.lastName);
        staffEditModule.setFirstNameKana(staffModule.staffDetail.firstNameKana);
        staffEditModule.setLastNameKana(staffModule.staffDetail.lastNameKana);
        staffEditModule.setIsDirector(staffModule.staffDetail.isDirector);
        staffEditModule.setIsChief(staffModule.staffDetail.isChief);
        staffEditModule.setIsAdmin((staffModule.staffDetail as any).isAdmin);
        staffEditModule.setEmail(staffModule.staffDetail.email);
        staffEditModule.setStaffCode1(staffModule.staffDetail.staffCode1 || "");
        staffEditModule.setStaffCode2(staffModule.staffDetail.staffCode2 || "");
        staffEditModule.setBirth(staffModule.staffDetail.birth);
        staffEditModule.setGender(staffModule.staffDetail.gender);
        staffEditModule.setAddress(staffModule.staffDetail.address || "");
        staffEditModule.setPhoneNumber1(
          staffModule.staffDetail.phoneNumber1 || ""
        );
        staffEditModule.setPhoneNumber2(
          staffModule.staffDetail.phoneNumber2 || ""
        );
        staffEditModule.setJoinDate(staffModule.staffDetail.joinDate);
        staffEditModule.setAssignDate(staffModule.staffDetail.assignDate);
        staffEditModule.setclassesInCharge(
          staffModule.staffDetail.classesInCharge.map((c) => {
            return c.classId;
          })
        );
        staffEditModule.setComment(staffModule.staffDetail.comment || "");
        staffEditModule.setRetireDate(staffModule.staffDetail.retireDate || "");
        staffEditModule.setRetireReason(
          staffModule.staffDetail.retireReason || ""
        );
        staffEditModule.setRetireReasonComment(
          staffModule.staffDetail.retireReasonComment || ""
        );
        staffEditModule.setIsHidden((staffModule.staffDetail as any).isHidden);
      }
    },
  },

});
</script>
